
import { Component, Vue } from 'vue-property-decorator';
import FooterBox from '@/components/Footer.vue';
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
@Component({
  components: {
    "footer-box": FooterBox,
  },
})
export default class App extends Vue {
  local = zh_CN
}
